<template>
  <div class="company-card">
    <div class="title-wrap">
      <h3 class="card-title">{{ company.displayName }}</h3>
      <svg
        class="close-icon"
        @click="hideCard"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.634766 14.8535L6.92773 8.4375L0.898438 2.28516L2.28711 0.878906L8.29883 7.03125L14.3281 0.878906L15.7168 2.28516L9.6875 8.4375L15.9805 14.8535L14.5918 16.2422L8.29883 9.84375L2.02344 16.2422L0.634766 14.8535Z"
          fill="#155EAD"
        ></path>
      </svg>
    </div>

    <div class="grey--text text--darken-2 subtitle-2 country-data">
      <country-icon class="country-icon"/>
      <span class="country-name">{{ company.data.baseCountry }}</span>
    </div>

    <div class="basic-data-wrap">
      <div v-if="company.data._consolidatedFinRevenueRange" class="company-data">
        <label>Revenue</label>
        <p>{{ formatRevenueRange(company.data._consolidatedFinRevenueRange) }}</p>
      </div>
      <div v-if="company.data._consolidatedEmployeeRange" class="company-data">
        <label>Employees</label>
        <p>{{ formatEmployeeRange(company.data._consolidatedEmployeeRange) }}</p>
      </div>
      <div v-if="company.data.sector" class="company-data">
        <label>Sector</label>
        <p>{{ company.data.sector }}</p>
      </div>
    </div>
    <div v-if="company.data.website" class="company-website">
      <label>Website</label>
      <p>
        <a :href="company.data.website">{{ company.data.website }}</a>
      </p>
    </div>
    <div v-if="company.data.principalActivities" class="company-description">
      <label>Description</label>
      <p>{{ company.data.principalActivities }}</p>
    </div>
    <div class="sdg-block">
      <sdg-item v-for="sdg in company.data.sdg" :key="sdg" :sdg="sdg"></sdg-item>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import format from '@/helpers/format'
import sdgItem from '@/components/sdg-item'
import countryIcon from '@/assets/icons/coordinates.svg?inline'

export default {
  name: 'company-card',
  components: {
    sdgItem,
    countryIcon,
  },
  props: {
    company: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    ...mapActions({
      setCard: 'map/setCard',
    }),
    formatToCurrency(num) {
      return format.formatToCurrency(num, 'USD')
    },
    formatRevenueRange(value) {
      return format.getRevenueRange(value)
    },
    formatEmployeeRange(value) {
      return format.getEmployeeRange(value)
    },
    hideCard() {
      this.setCard({})
    },
  },
}
</script>

<style lang="scss" scoped>
.company-card {
  max-width: 478px;
  padding: 56px;
  background: #fff;
  position: absolute;
  font-size: 14px;
  top: 10px;
  right: 0px;
  border-radius: 8px 0px 0px 8px;
  box-shadow: 0px 0px 20px rgba(7, 61, 125, 0.2);
  z-index: 100;
}
.title-wrap {
  position: relative;
}
.close-icon {
  position: absolute;
  top: 5px;
  right: -20px;
  cursor: pointer;
}
.country-data {
  position: relative;
}
.country-name {
  padding-left: 18px;
}
.country-icon {
  position: absolute;
  top: 2px;
  left: 0px;
}
.card-title {
  font-size: 24px;
  line-height: 1.1;
  font-weight: normal;
  margin-bottom: 10px;
}
.basic-data-wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.company-data label,
.company-website label,
.company-description label {
  font-size: 12px;
  color: #8f949a;
}
.sdg-block {
  margin-top: 40px;
}
</style>
